import React from "react";
import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";

/**
 * Settings layout: a bold label-size heading over plain rows
 * split by dividers, each row a label, a line of detail, and one action on the right.
 */
export const SettingsSection = ({ title, aside, children }) => (
  <Box component="section" sx={{ mb: 4 }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        mb: 1,
      }}
    >
      <Typography variant="subtitle2" component="h3" fontWeight="bold">
        {title}
      </Typography>
      {aside}
    </Box>
    {/* Rows are split by dividers; the section heading below already separates
        the last row from what follows. */}
    <List disablePadding sx={{ "& > li:last-of-type": { borderBottom: 0 } }}>
      {children}
    </List>
  </Box>
);

export const SettingsRow = ({ label, detail, action }) => (
  <ListItem divider disableGutters sx={{ py: 1.5, gap: 2 }}>
    <ListItemText
      primary={label}
      secondary={detail}
      secondaryTypographyProps={{ sx: { overflowWrap: "anywhere" } }}
      sx={{ m: 0 }}
    />
    {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
  </ListItem>
);
